import { LIVE_FLAG_LABEL } from "../Variants/VerticalToHorizontalCard/constants";
import Badge from "../../Badge";
import { BadgeTypes } from "../../Badge/interface";

export const getBadge = (
    status: string | undefined,
    label: string | undefined,
    className: string | undefined
) => {
    if (status?.toLowerCase() === LIVE_FLAG_LABEL) {
        return (
            <Badge text={"LIVE"} type={BadgeTypes.Live} className={className} />
        );
    }

    return (
        label && (
            <Badge text={label} type={BadgeTypes.Topic} className={className} />
        )
    );
};

export const getStatus = (
    status: string | undefined,
    className: string | undefined
) => {
    if (status?.toLowerCase() === LIVE_FLAG_LABEL) return;

    return status && <span className={className}>{`${status} `}</span>;
};

/**
 * Generates an accessible ARIA label for a given content item
 * (e.g., "Economy. Updated. A news article title.")
 *
 * @param {string | undefined} status - status of content (e.g., "Live").
 * @param {string | undefined} label -  topic label for content
 * @param {string | undefined} title - headline of the content
 * @param {boolean} isVideoContent - flag indicating if content is a video.
 *
 * @returns {string | undefined} - The ARIA label for accessibility, or undefined if no title is provided.
 */
export const getAriaLabel = (
    status: string | undefined,
    label: string | undefined,
    title: string | undefined,
    isVideoContent: boolean
) => {
    if (!title) return;

    if (status?.toLowerCase() === LIVE_FLAG_LABEL) {
        return `${status}. ${title}`;
    }

    let ariaLabel = "";

    if (label) ariaLabel += `${label}. `;
    if (status) ariaLabel += `${status}. `;
    ariaLabel += `${title}. `;
    if (isVideoContent)
        ariaLabel += "Video Content. Closed Captioning Available.";

    return ariaLabel;
};
